/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
    export class Login {
        public static inicializar() {
            var login = new App.Login();
            login.inicializarEventos();
        }
    }
}

namespace App {
    export class Login {
        private appElectronMessage: AppElectronMessage = null;
        private ajax: IAjax;


        public inicializarEventos() {
            this.ajax = new App.Ajax();
            $('form').on('submit', (e) => { this.aoSubmeterFormulario(e) });
            this.appElectronMessage = new AppElectronMessage();
            let objgrecaptcha = new Grecaptcha();
            objgrecaptcha.inicializar();
            this.recuperarUltimoLogin()
        }

        private aoSubmeterFormulario(e: JQueryEventObject) {
            this.appElectronMessage.sendMessage({ tipo: "setUltimoLogin", dados: { email: $('input[name=email]').val(), password: $('input[name=password]').val() } }, (resposta: any) => { })
        }

        private recuperarUltimoLogin() {
            this.appElectronMessage.sendMessage({ tipo: "getUltimoLogin", dados: null }, (resposta: { email: string, password: string }) => {
                $('input[name=email]').val(resposta.email)
                $('input[name=password]').val(resposta.password)
            })
        }
    }
}
